








































import {Component, Prop} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {CreatePatTScheme, SavePatPreTemp} from "@/api/patient"
import {GetListByCode} from "@/api/configureDictionary"

@Component
export default class AddOrEdit extends AbpBase {
	@Prop() value: boolean
	@Prop() data: any
	model: any = {}
	//透析频率集合 来自配置项字典
	dlyFrequencys = []
	//治疗方式(透析模式)集合 来自配置项字典
	dialysisWays = []

	created() {
		this.getSelect()
	}

	async save() {
		(this.$refs.form as any).validate(async (valid: boolean) => {
			if (valid) {
				this.model.dialysisWay = this.model.dialysisWayList.toString()
				this.model.patientId = this.data.patient.id
				let res = await CreatePatTScheme(this.model)
				if (res.status === 1) {
					this.$emit('save-success')
				}
			}
		})

	}

	get modalTitle() {
		return `新增${this.data.name}`
	}

	cancel() {
		this.$emit('input', false)
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}

	rules = {
		dlyFrequency: [{required: true, message: '请选择透析频率'}],
		dialysisWayList: [{required: true, message: '请选择'}],
		dialysateCa: [{required: true, message: '请选择'}],
	}

	private async getSelect() {
		let res = await GetListByCode({input: '027'})
		this.dlyFrequencys = res
		let res1 = await GetListByCode({input: '025'})
		this.dialysisWays = res1
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/dialysisPre/addOrEdit.vue